<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Driver Profile") }}</h3>
    </v-btn>
    <v-btn
      color="white"
      style="float: right"
      small
      class="tariff-right-headers"
      v-if="driver.addedDay"
      >Added at: {{ driver.addedDay }}</v-btn
    >
    <v-btn
      color="white"
      style="float: right"
      small
      class="tariff-right-headers"
      v-if="driver.addedBy"
      >Added by: {{ driver.addedBy }}</v-btn
    >
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="12" md="3" lg="3">
        <z-vendor-select
          withSelf
          :label="$i18n.t('Owner')"
          v-model="driver.driverOf"
          :disabled="!driver.iamOwner && isEdit"
        ></z-vendor-select>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <z-client-select
          withSelf
          :label="$i18n.t('Assigned To')"
          v-if="driver.showAssignedTo"
          v-model="driver.assignedTo"
        ></z-client-select>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <!-- <v-select
          :items="driverTypes"
          :label="$i18n.t('Type')"
          v-model="driver.type"
        ></v-select> -->

        <v-btn-toggle rounded style="float: left; background: transparent">
          <v-btn
            small
            :color="driver.type === 1 ? 'secondary' : 'grey'"
            @click="driver.type = 1"
          >
            <h3 style="padding-right: 20px">
              <div
                style="width: 20px; height: 12px; float: left"
                v-if="driver.type !== 1"
              ></div>
              <v-icon v-if="driver.type === 1" color="white">mdi-check</v-icon>
              {{ $i18n.t("Driver") }}
            </h3>
          </v-btn>

          <v-btn
            small
            :color="driver.type === 2 ? 'secondary' : 'grey'"
            @click="driver.type = 2"
          >
            <h3 style="padding-right: 20px">
              <div
                style="width: 20px; height: 12px; float: left"
                v-if="driver.type !== 2"
              ></div>
              <v-icon v-if="driver.type === 2" color="white">mdi-check</v-icon>
              {{ $i18n.t("Helper") }}
            </h3>
          </v-btn>
          <v-btn
            small
            :color="driver.type === 3 ? 'secondary' : 'grey'"
            @click="driver.type = 3"
          >
            <h3 style="padding-right: 20px">
              <div
                style="width: 20px; height: 12px; float: left"
                v-if="driver.type !== 3"
              ></div>
              <v-icon v-if="driver.type === 3" color="white">mdi-check</v-icon>
              {{ $i18n.t("Employee") }}
            </h3>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Name')"
          v-model="driver.name"
          :oninput="(driver.driverDetail.name = driver.name)"
          :rules="validationrules.name"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Parent Name')"
          v-model="driver.driverDetail.parentName"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-row>
          <v-col cols="12" md="4">
            <z-country-select
              isd
              hideName
              hideFlag
              v-model="driver.countryCode"
              :rules="validationrules.countryCode"
              :label="$i18n.t('Code')"
            />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              :label="$i18n.t('Phone')"
              v-model="driver.phone"
              :rules="validationrules.phone"
              type="number"
              maxlength="12"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-zone-select v-model="driver.zone_id" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Email')"
          v-model="driver.driverDetail.email"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('Date of Birth')"
          v-model="driver.driverDetail.dob"
        ></z-date-picker>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Employee ID')"
          v-model="driver.driverDetail.empNo"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('Status')"
          :items="[
            { name: 'Unverified', value: 0 },
            { name: 'Verified', value: 1 },
            { name: 'Restricted', value: 2 },
            { name: 'Wanted', value: 3 },
          ]"
          v-model="driver.status"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Drivers License')"
          v-model="driver.driverDetail.dlNo"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('DL Issue')"
          v-model="driver.driverDetail.DLIssue"
        ></z-date-picker>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('DL Expiry')"
          v-model="driver.driverDetail.dlExpiry"
        ></z-date-picker>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('License Issued By')"
          v-model="driver.driverDetail.dlIssuedBy"
          maxlength="35"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-autocomplete
          :label="$i18n.t('License Vehicle Type')"
          :items="licenseTypes"
          v-model="driver.driverDetail.dlVehicleType"
          item-text="name"
          item-value="value"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Profile",
  props: {
    value: {
      default: null,
    },
    isEdit: {
      default: null,
    },
  },
})
export default class Profile extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    countryCode: [(v) => !!v || this.$i18n.t("Country code is required")],
    phone: [(v) => !!v || this.$i18n.t("Seats is required")],
    dlNo: [(v) => !!v || this.$i18n.t("Color is required")],
  };

  driverTypes = [
    { text: "Driver", value: 1 },
    { text: "Helper", value: 2 },
    { text: "Employee", value: 3 },
  ];

  licenseTypes = [
    { name: "LMV", value: "LMV" },
    { name: "LMV – GV", value: "LMV – GV" },
    { name: "LMV – MT", value: "LMV – MT" },
    { name: "LMV – NT", value: "LMV – NT" },
    { name: "LMV – TR", value: "LMV – TR" },
    { name: "HMV", value: "HMV" },
  ];

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>